<template>
  <!-- 二维码页面 -->
  <div class="QRCode_box">
    <div class="QRCode_wrapper">
      <!-- 二维码页面 -->
      <van-nav-bar title="付款码" @click-left="closeQRCode(() => {})">
        <template #left>
          <span class="icon-left"></span>
        </template>
      </van-nav-bar>

      <!-- 页面中央区域 -->
      <div class="QRCode_content">
        <div class="content_box">
          <div class="content_tile">扫我付款</div>

          <!-- 银联、阿里、微信 -->
          <div class="content_foot">
            <div class="union">
              <span class="icon-union">
                <span class="path1"></span>
                <span class="path2"></span>
                <span class="path3"></span>
                <span class="path4"></span>
              </span>
            </div>
            <div class="wx">
              <span class="icon-wx"></span>
            </div>
            <div class="Ali">
              <span class="icon-ali"></span>
            </div>
          </div>

          <!-- 中心二維碼 -->
          <div class="content_qrCode">
            <!-- <span class="icon-qrCode"></span> -->
            <!-- <div class="qrCode-box" v-if="!isRegenerate">
              <img
                v-if="qrCodeSrc"
                class="qrcodeImg"
                :src="qrCodeSrc"
                alt="加载失败"
              />
            </div> -->

            <div v-if="!isRegenerate" id="qrcode" ref="qrcode"></div>
            <div @click="payAgain" v-else class="regenerate">
              点击重新生成二维码
            </div>
          </div>
        </div>
      </div>

      <div class="scan_box" @click="onPay">
        <div class="scan">
          <div class="scan_ico">
            <img src="../assets/images/scan.png" alt="" />
          </div>
          扫码付款
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import QRCode from "qrcodejs2";
import {
  ORDER_PARKING_QRCODE,
  ORDER_PARKING_GET_ORDER_STATUS,
  ORDER_PARKING_UPDATE_PAY_FAIL_ORDER
} from "../config/config";
// import { Toast } from "vant";

export default {
  name: "QRCode",

  data: () => ({
    isRegenerate: false, //是否重新生成二维码
    paymentNoteId: "",
    qrCodeSrc: ""
  }),

  methods: {
    onPay() {
      this.$emit("onPay", this.orderParkingId);
    },

    payAgain() {
      this.$utils.showLoading();

      // if (this.isFirst) {
      //   this.payAgainRequest(() => {
      //     this.qrcode(this.orderParkingId, this.qrCodePollRequest());
      //   });
      // } else {
      let params = {
        orderParkingId: this.orderParkingId
      };
      if (this.stationId) {
        params = {
          ...params,
          stationId: this.stationId
        };
      }
      this.qrcode(params, this.qrCodePollRequest);
      // }
    },

    //更新失败订单
    payAgainRequest(callback) {
      this.$request(
        ORDER_PARKING_UPDATE_PAY_FAIL_ORDER,
        {
          orderParkingId: this.orderParkingId
        },
        () => {
          callback();
        }
      );
    },

    //初始化二维码
    qrcode(params, callback) {
      this.$request(this.qrCodeInterFace, params, async res => {
        this.$utils.closeLoading();
        this.$refs.qrcode.innerHTML = "";
        // this.qrCodeSrc = "";

        if (this.$condition.isRequestSuccess(res)) {
          // this.qrCodeSrc = await this.$utils.convertQRCode(
          //   res["data"]["qrUrl"]
          // );
          this.qrcodeObj = new QRCode("qrcode", {
            width: 220, // 设置宽度，单位像素
            height: 220, // 设置高度，单位像素
            text: res["data"]["qrUrl"], // 设置二维码内容或跳转地址
            correctLevel: QRCode.CorrectLevel.Q
          });

          this.paymentNoteId = res["data"]["paymentNoteId"];

          setTimeout(() => {
            callback();
          }, 4000);
        } else {
          this.isRegenerate = true;
        }
      });
    },

    //二维码显示轮询
    qrCodePollRequest() {
      if (this.showQRCode) {
        this.$request(
          ORDER_PARKING_GET_ORDER_STATUS,
          { paymentNoteId: this.paymentNoteId },
          res => {
            //请求接口成功
            if (this.$condition.isRequestSuccess(res)) {
              //当支付单状态为支付中
              if (this.$condition.isOrderStatus_abnormal(res["data"])) {
                if (this.pollRequestTimeout) {
                  clearTimeout(this.pollRequestTimeout);
                }

                //返回轮询方法，继续查询
                return (this.pollRequestTimeout = setTimeout(() => {
                  this.qrCodePollRequest();
                }, 1000));
              } else if (this.$condition.isOrderStatus_success(res["data"])) {
                //回退原生
                // this.$utils.goBack();

                // //跳转原生支付成功页面
                // this.$utils.orderParkingId(this.orderParkingId);

                this.$emit("successCallback");
              } else if (this.$condition.isOrderStatus_fail(res["data"])) {
                this.$emit("failCallback");
              }
            }
          }
        );
      } else {
        if (this.pollRequestTimeout) {
          clearTimeout(this.pollRequestTimeout);
        }
      }
    },

    closeQRCode(callback) {
      if (this.pollRequestTimeout) {
        clearTimeout(this.pollRequestTimeout);
      }
      this.$emit("closeQRCode");
      this.$nextTick(() => {
        callback();
      });
    }
  },

  props: {
    orderParkingId: {
      required: true,
      type: String
    },

    showQRCode: {
      required: true,
      type: Boolean
    },

    isFirst: {
      type: Boolean,
      default: false
    },

    qrCodeInterFace: {
      type: String,
      default: ORDER_PARKING_QRCODE
    },

    stationId: {
      type: String,
      default: null
    }
  },

  watch: {
    showQRCode(newV) {
      if (newV) this.payAgain();
    }
  },

  beforeDestroy() {
    if (this.pollRequestTimeout) {
      clearTimeout(this.pollRequestTimeout);
    }
  }
};
</script>

<style lang="less" scoped>
.QRCode_box {
  position: absolute;
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  z-index: 100;

  .QRCode_wrapper {
    width: 100vw;
    height: 100vh;
    position: absolute;
    top: 0;
    left: 0;
    background-color: rgb(235, 235, 235);
    padding-top: 26px;

    .van-nav-bar {
      background-color: rgb(235, 235, 235);

      .icon-left {
        font-size: 24px;
        margin-right: 6px;
        color: #333;
      }

      /deep/ .van-nav-bar__title {
        font-size: 20px;
      }
    }
  }

  .QRCode_content {
    width: 100vw;
    padding: 80px 16px 20px;
    display: flex;
    justify-content: center;
    align-items: center;

    .content_box {
      width: 100%;
      height: 430px;
      margin: 0 auto;
      background-color: #fff;
      border-radius: 8px;
      overflow: hidden;
      display: flex;
      justify-content: center;
      align-items: center;
      position: relative;

      .content_tile {
        width: 100%;
        font-size: 24px;
        text-align: center;
        position: absolute;
        top: 20px;
      }

      .content_foot {
        width: 100%;
        padding: 0 30px;
        position: absolute;
        bottom: 10px;
        display: flex;
        justify-content: space-around;

        span {
          font-size: 40px;
        }
      }

      .content_qrCode {
        width: 250px;
        height: 250px;
        display: flex;
        justify-content: center;
        align-items: center;

        #qrcode {
          width: 100%;
          height: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
        }

        img {
          display: block;
          width: 100%;
          height: 100%;
        }

        .qrCode-box {
          width: 100%;
          height: 100%;
          background: #fff;

          .qrcodeImg {
            display: block;
            width: 100%;
            height: 100%;
          }
        }

        .regenerate {
          font-size: 20px;
          color: blue;
        }
      }
    }
  }
  .loading {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 51;
    width: 100%;
    height: 100%;
    background-color: rgba(7, 17, 27, 0.7);
    display: flex;
    justify-content: center;
    align-items: center;

    .van-loading {
      color: #fff;
      font-size: 24px;
    }

    .van-loading__text {
      color: #fff;
    }
  }
}

.scan_box {
  width: 260px;
  height: 50px;
  margin: 0 auto;
  padding: 0 16px;
  background-color: #fff;
  border-radius: 20px;

  .scan {
    width: 200px;
    height: 100%;
    margin: 0 auto;
    display: flex;
    align-items: center;
    font-size: 20px;
    padding: 0 20px;

    .scan_ico {
      height: 30px;
      margin-right: 20px;

      img {
        height: 100%;
        width: auto;
      }
    }
  }
}
</style>
